import { ComponentStepProps } from "#/ui/Modal"

import { IncreaseAmountStep } from "./increase-amount"
import { ManageType, useManageStakeFlowContext } from "./ManageStakeFlowContext"

export const UPDATE_STAKE_STEP_TITLE: Record<ManageType, string> = {
  "increase-amount": "Increase amount",
  "increase-lock-duration": "Increase lock duration",
}

export default function UpdateStakeStep(props: ComponentStepProps) {
  const { manageType } = useManageStakeFlowContext()

  if (manageType === "increase-amount") return <IncreaseAmountStep {...props} />

  return null
}
